import { useEffect } from 'react'
import Header from '../../components/Header'
import HeaderImage from '../../Imagenes/INSTALACIONES/DSC_3301.jpg'
import StoryImage from '../../Imagenes/empresa.jpg'
import VisionImage from '../../Imagenes/visionexe.jpg'
import MissionImage from '../../Imagenes/misionexe.jpg'
import ValuesImage from '../../Imagenes/values.jpg'
import './about.css'

const About = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className="about-page">
      {/* HEADER */}
      <Header
        title="Sobre Nosotros"
        image={HeaderImage}
      >
        Comprendemos y compartimos los sentimientos de los demás, la empatía nos
        permite ver las cosas desde la perspectiva del otro en vez de la nuestra.
      </Header>

      {/* HISTORIA */}
      <section className="about-section">
        <div className="about-section-container">
          <div className="about-section-image">
            <img src={StoryImage} alt="Nuestra Historia" />
          </div>
          <div className="about-section-content">
            <h1>Nuestra Historia</h1>
            <p>
              Exequiales IESS es una compañía acreditada por el Instituto Ecuatoriano de Seguridad Social 
              como prestadora de Servicios Funerarios, consolidada en el año 2014 con capital accionario del IESS y 
              BIESS. Su objetivo es brindar tranquilidad a las familias de los afiliados al IESS, pensionistas de montepío, 
              jubilados y al público en general, entregando un servicio de calidad que se adapte a sus necesidades
            </p>
          </div>
        </div>
      </section>

      {/* VISIÓN */}
      <section className="about-section">
        <div className="about-section-container reverse">
          <div className="about-section-content">
            <h1>Nuestra Visión</h1>
            <p>
              Ser una empresa líder en la prestación de servicios funerarios a nivel nacional mediante nuestra atención de calidad y 
              servicio integral basado en la ética, respeto y cultura organizacional orientada al cliente.
            </p>
          </div>
          <div className="about-section-image">
            <img src={VisionImage} alt="Nuestra Visión" />
          </div>
        </div>
      </section>

      {/* MISIÓN */}
      <section className="about-section">
        <div className="about-section-container">
          <div className="about-section-image">
            <img src={MissionImage} alt="Nuestra Misión" />
          </div>
          <div className="about-section-content">
            <h1>Nuestra Misión</h1>
            <p>
              Ofrecer servicios funerarios de alta calidad a los afiliados, jubilados, pensionistas de montepío del IESS y 
              público en general; pensando siempre en su tranquilidad, seguridad, paz y confianza.
            </p>
          </div>
        </div>
      </section>

      {/* VALORES */}
      <section className="about-section">
        <div className="about-section-container reverse">
          <div className="about-section-content">
            <h1>Nuestros Valores</h1>
            <p><strong>Respeto</strong></p>
            <p><strong>Solidaridad</strong></p>
            <p><strong>Calidad</strong></p>
            <p><strong>Responsabilidad</strong></p>
          </div>
          <div className="about-section-image">
            <img src={ValuesImage} alt="Nuestros Valores" />
          </div>
        </div>
      </section>
    </main>
  )
}

export default About
